import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { CmpsTeamsCallChatMenuDialogModule } from '../dialog';

import { ChatMenuNavButtonComponent } from './chat-menu-nav-button.component';
import { TranslationIdMap } from './chat-menu-nav-button.i18n';

@NgModule({
    declarations: [ChatMenuNavButtonComponent],
    exports: [ChatMenuNavButtonComponent],
    imports: [
        CmpsButtonModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTeamsCallChatMenuDialogModule,
        CmpsTooltipModule,
        CommonModule,
    ],
})
export class CmpsTeamsCallChatMenuNavButtonModule {}
